var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeerGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E5B5"
    },
    d: "M204.866,352.668c0-56.064,44.238-94.239,44.238-196.251C249.104,95.211,226.605,0,226.605,0 H124.552H22.499C22.499,0,0,95.211,0,156.417c0,102.012,44.238,140.187,44.238,196.251c0,75.78,0.231,127.961-8.292,138.93 C27.446,502.539,37.89,512,45.662,512s78.89,0,78.89,0s71.117,0,78.89,0s18.19-9.703,9.715-20.402 C204.531,480.709,204.866,428.448,204.866,352.668z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.5713,
    y1: 482.876,
    x2: 124.5713,
    y2: 29.1415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7CE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7635,
    style: {
      stopColor: "#E68930"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M175.701,352.681v7.21c0,64.24,0.303,100.546,4.185,122.985H69.205 c3.933-22.439,4.185-58.744,4.185-122.985v-7.21c0-29.347-9.329-53.349-19.212-78.763c-11.749-30.154-25.01-64.392-25.01-117.488 c0-21.178,2.925-46.995,6.656-71.249h177.443c3.731,24.254,6.706,50.121,6.706,71.249c0,53.096-13.312,87.334-25.061,117.488 C185.03,299.332,175.701,323.334,175.701,352.681z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 70.712,
    cy: 113.486,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 70.712,
    cy: 181.331,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 110.676,
    cy: 143.217,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 126.725,
    cy: 227.802,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 148.229,
    cy: 181.331,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 180.184,
    cy: 111.267,
    r: 6.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#F7F7F7"
    },
    cx: 188.856,
    cy: 178.069,
    r: 6.938
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.04,
      fill: "#040000"
    },
    d: "M124.552,0h102.053c0,0,22.499,95.211,22.499,156.417 c0,102.011-44.238,140.187-44.238,196.25c0,75.78-0.334,128.041,8.291,138.93c8.475,10.699-1.943,20.402-9.715,20.402 c-7.772,0-78.89,0-78.89,0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerGlass);
export default __webpack_public_path__ + "static/media/beer-glass.6ac4ffe1167bdd1a72e692a0f4941c0e.svg";
export { ForwardRef as ReactComponent };